/*
Ref:
https://developers.google.com/codelabs/chrome-web-vitals-js

Metrics:
CLS - Cumulative Layout Shift. Measures visual stability and should be within 0.1 seconds.
FCP - First Contentful Paint. Measures initial rendering and should occur within 1 second.
INP - Interaction to Next Paint. Measures interactivity and should occur within 0.2 seconds.
LCP - Largest Contentful Paint. Measures load performance and should occur within 2.5 seconds of when page begins load.
TTFB - Time to First Byte. Measures server response time and should be under 0.6 seconds.
*/

const reportWebVitals = (onPerfEntry?: (metric: import("web-vitals").Metric) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ onCLS, onFCP, onINP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFCP(onPerfEntry);
      onINP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
